import { LOCATION_CHANGE } from 'react-router-redux';

import { takeEvery, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import takeConditional from '../effects/takeConditional';
import takeLatestByPayload from '../effects/takeLatestByPayload';

import changeLocale, { sagaChangeLocale } from './changeLocale';
import fetch, { sagaFetch } from './fetch';
import fetchBulk, { sagaFetchBulk } from './fetchBulk';
import fetchList, { sagaFetchList } from './fetchList';
import fetchLookups, { sagaFetchLookups } from './fetchLookups';
import fetchPage, { sagaFetchPage } from './fetchPage';
import remove, { sagaRemove } from './remove';
import request, { sagaRequest } from './request';
import resetEntitiesFromSocket, { sagaResetEntitiesFromSocket } from './resetEntitiesFromSocket';
import sagaLocationChange from './sagaLocationChange';
import sagaUpdateFetchKeyDelayed from './sagaUpdateFetchKeyDelayed';
import save, { sagaSave } from './save';
import updateFetchKeyDelayed from './updateFetchKeyDelayed';

export default function* saga() {
  yield takeConditional(getType(fetchPage.request), sagaFetchPage);
  yield takeEvery(getType(changeLocale), sagaChangeLocale);
  yield takeEvery(getType(fetch.request), sagaFetch);
  yield takeEvery(getType(fetchBulk.request), sagaFetchBulk);
  yield takeEvery(getType(fetchList.request), sagaFetchList);
  yield takeEvery(getType(fetchLookups), sagaFetchLookups);
  yield takeEvery(getType(remove.request), sagaRemove);
  yield takeEvery(getType(request.request), sagaRequest);
  yield takeEvery(getType(resetEntitiesFromSocket), sagaResetEntitiesFromSocket);
  yield takeEvery(LOCATION_CHANGE, sagaLocationChange);
  yield takeLatest(getType(save.request), sagaSave);
  yield takeLatestByPayload(getType(updateFetchKeyDelayed), sagaUpdateFetchKeyDelayed);
}
